import { useState } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    Button,
    Image,
    Card,
    Popover,
    OverlayTrigger,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import stdnt from "../assets/images/student.png";
import schl from "../assets/images/school.png";
import hsptl from "../assets/images/hospital.png";
import sign_img from "../assets/images/sign_img.png";
import { BsFillCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { MdChecklist, MdOutlineAutoGraph, MdOutlineHelp } from "react-icons/md";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { showErrorMessage, showSuccessMessage } from "../services/utils";


const ResetPassword = () => {
    const navigate = useNavigate()
    const BaseURL = process.env.REACT_APP_BASE_URL
    const { token } = useParams()

    const [password, SetPassword] = useState("")
    const [new_password, SetNew_password] = useState("")
    const [loading, setLoading] = useState(false)

    function resetEmail(e) {

        e.preventDefault()

        if (password === new_password) {
            const body = {
                new_password: new_password,
            }


            const options = {
                method: 'POST',
                url: `${BaseURL}ResetUserPassword`,
                headers: {'Content-Type': 'application/json', Authorization: token},
                data: body
              };
              
              axios.request(options).then(function (response) {
                showSuccessMessage({message:"Password Changed"})
                navigate("/")
              }).catch(function (error) {
                console.error(error);
              });

          
        }
        else{
            showErrorMessage({message:"Password and Confirm Password needs to be same  "})
        }


    }
    return (
        <div className="signup_pg">
            <Container fluid>
                <div className="signup_pg_wrap">
                    <Row className="justify-content-center align-items-start">
                        <Col md={6}>
                            <div className="signup_form">
                                <div className="sign_hdng">
                                    <h2>Reset Password</h2>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur
                                        adipisicing elit. Ullam aperiam
                                        similique cum excepturi, officiis saepe
                                        id vitae quod soluta
                                    </p>
                                </div>
                                <Form className="signform_div" onSubmit={(e) => (resetEmail(e))}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword"
                                    >
                                        <Form.Label>New Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Enter New Password"
                                            value={password}
                                            onChange={(e) => (SetPassword(e.target.value))}
                                        />
                                        <Form.Text className="text-muted">
                                            Minimum 8 characters, at least one
                                            alpha, special, numeric, upper &
                                            lower case
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group
                                        className="mb-3"
                                        controlId="formBasicPassword"
                                    >
                                        <Form.Label>
                                            Confirm Password
                                        </Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={new_password}
                                            placeholder="Confirm Password"
                                            onChange={(e) => (SetNew_password(e.target.value))}
                                        />
                                    </Form.Group>

                                    {/* <p className="sign_agree">
                                        By signing up, you are indicating that
                                        you have read and agree to the{" "}
                                        <a href="#" className="bld_link">
                                            Terms of Use
                                        </a>{" "}
                                        and{" "}
                                        <a href="#" className="bld_link">
                                            Privacy Policy
                                        </a>
                                        .
                                    </p> */}
                                    <Button
                                        className="btn_theme w-100 mt-4"
                                        type="submit"
                                        variant=""
                                    >
                                        Submit
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                        <Col md={6} className="pe-0 sticky_col">
                            <div className="signuprt_div">
                                <div className="sign_logo mb-5">
                                    <a href="/">
                                        <Image src={Logo} fluid />
                                    </a>
                                </div>
                                <div className="sign_img">
                                    <Image src={sign_img} fluid />
                                </div>
                                <div className="wb_ftrs">
                                    <ul>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <MdOutlineAutoGraph />
                                                </span>
                                                <span>
                                                    Streamlined and High
                                                    efficiency
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <MdChecklist />
                                                </span>
                                                <span>
                                                    Organized and Comprehensive
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="prnt_ftr">
                                                <span className="ftr_icn">
                                                    <HiOutlineClipboardCheck />
                                                </span>
                                                <span>
                                                    HIPAA and FERPA Compliant
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default ResetPassword;
